import type { JSX } from 'react';
import { Briefcase, Zap, Code2, Layers } from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import { useContent } from '@data';
import { useT } from '@/i18n';
import { SectionHeader } from '@components/ui';
import './Contact.css';

type IconComp = React.ComponentType<LucideProps>;

const ICON_MAP = { Briefcase, Zap, Code2, Layers } satisfies Record<string, IconComp>;

export default function Contact(): JSX.Element {
  const { CONTACT_CARDS, CONTACT_CTA, CONTACT_PLACE, LINKEDIN_URL, CV_URL, CONTACT_CV_LABEL } = useContent();
  const t = useT();

  return (
    <section id="contact" className="section Contact">
      <SectionHeader
        chip={t.sections.contact.chip}
        chipVariant="p"
        title={t.sections.contact.title}
        subtitle={t.sections.contact.subtitle}
      />

      <div className="Contact__cards">
        {CONTACT_CARDS.map(card => {
          const Icon = ICON_MAP[card.icon];
          return (
            <article
              key={card.id}
              className="ContactCard"
              style={{
                '--card-color':     card.colorVar,
                '--card-color-rgb': card.colorRgbVar,
              } as React.CSSProperties}
            >
              <span className="ContactCard__icon" aria-hidden="true">
                <Icon size={20} strokeWidth={1.5} />
              </span>
              <h3 className="ContactCard__title">{card.title}</h3>
              <p className="ContactCard__body">{card.body}</p>
            </article>
          );
        })}
      </div>

      <div className="Contact__cta">
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary Contact__btn"
        >
          {CONTACT_CTA}
        </a>
        <a href={CV_URL} download className="btn-secondary Contact__btn">
          {CONTACT_CV_LABEL}
        </a>
        <p className="Contact__meta">
          {CONTACT_PLACE}
          <span className="Contact__meta-sep"> · </span>
          <span className="Contact__meta-ok">{t.sections.contact.available}</span>
        </p>
      </div>
    </section>
  );
}
